module.exports = __webpack_public_path__ + "static/media/biobank_distribution.e5f3125e.pdf";